import './subscriptionCard.scss'

export interface SubscriptionCardProps {
  type: string
  name: string
  price: string | number
  duration: string
  isActive: boolean
  onHandleSelectSubscription: () => void
}

export const SubscriptionCard = (props: SubscriptionCardProps) => {
  const { type, name, price, duration, isActive, onHandleSelectSubscription } = props
  return (
    <div
      className={`subscription-card ${isActive && 'subscription-card__disable'}`}
      role="button"
      onClick={onHandleSelectSubscription}
    >
      <p className="subscription-card__type">{type}</p>

      <div className="subscription-card__block">
        <p className="subscription-card__name">{name}</p>
        <p className="subscription-card__price">${price}</p>
        <p className="subscription-card__duration">/{duration}</p>
      </div>
    </div>
  )
}
